module.exports = __webpack_public_path__ + "static/media/activate-key-kiper.e67d6712.svg";